"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var goodsNameTagApi = _interopRequireWildcard(require("@/api/goodsNameTagApi.js"));
var _editDialog = _interopRequireDefault(require("./editDialog.vue"));
var _goodsManage = _interopRequireDefault(require("./goodsManage.vue"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    EditDialog: _editDialog.default,
    GoodsManage: _goodsManage.default
  },
  data: function data() {
    return {
      constants: this.$constants,
      listPram: {
        labelName: '',
        page: 1,
        limit: this.$constants.page.limit[0]
      },
      listData: {
        list: [],
        total: 0
      },
      listLoading: true
    };
  },
  mounted: function mounted() {
    this.handlerGetListData();
  },
  methods: {
    handerSearch: function handerSearch() {
      this.listPram.page = 1;
      this.handlerGetListData();
    },
    handleResetSearch: function handleResetSearch() {
      this.listPram.labelName = '';
      this.listPram.page = 1;
      this.handlerGetListData();
    },
    handlerGetListData: function handlerGetListData() {
      var _this = this;
      this.listLoading = true;
      goodsNameTagApi.listApi(this.listPram).then(function (data) {
        _this.listData = data || {
          list: [],
          total: 0
        };
        _this.listLoading = false;
      }).catch(function () {
        _this.listLoading = false;
      });
    },
    handlerOpenEdit: function handlerOpenEdit(row) {
      this.$refs.EditDialogRef.openInit(row || {});
    },
    handlerDelete: function handlerDelete(rowData) {
      var _this2 = this;
      this.$confirm('删除后该标签绑定的商品移动端将被移除，确认删除？', '提示').then(function () {
        goodsNameTagApi.deleteApi(rowData).then(function () {
          _this2.$message.success('删除数据成功');
          _this2.handlerGetListData();
        });
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listPram.limit = val;
      this.handlerGetListData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listPram.page = val;
      this.handlerGetListData();
    },
    onchangeIsShow: function onchangeIsShow(row) {
      var _this3 = this;
      goodsNameTagApi.updateStatusApi(row).then(function () {
        _this3.$message.success('修改成功');
        _this3.handlerGetListData();
      }).catch(function () {
        _this3.handlerGetListData();
      });
    },
    handleSortChange: function handleSortChange(row, val) {
      var _this4 = this;
      var sort = Number(val);
      if (Number.isNaN(sort) || sort < 0) sort = 0;
      row.sort = sort;
      goodsNameTagApi.updateSortApi({
        id: row.id,
        sort: sort
      }).then(function () {
        _this4.$message.success('排序更新成功');
        _this4.handlerGetListData();
      }).catch(function () {
        _this4.handlerGetListData();
      });
    },
    handlerGoodsTag: function handlerGoodsTag(row) {
      this.$refs.GoodsManageRef.initOpen(row, 1);
    }
  }
};